// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/deals-list/deals-list.component.scss
// module id = 402
// module chunks = 0